import { ArrowLeft } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import { usePremisesStore, useRegionStore } from "../../store/store";
import axios from "axios";
import axiosInstance from "../../common/axiosInstance";
import { proxyUrl } from "../../common/utils";

const AddPremises: React.FC = () => {
  const { id } = useParams<{ id: any }>();
  const location = useLocation();
  const path = location.pathname.split("/");
  const isView = path[1] === "view-premises";

  const navigate = useNavigate();

  const { setPremises } = usePremisesStore();
  const { regions, fetchRegions } = useRegionStore();

  const [addPremises, setAddPremises] = useState({
    region: "",
    premisesName: "",
    addressLine1: "",
    townCity: "",
    postcode: "",
    responsiblePerson: "",
    floor: undefined as number | undefined,
    basement: false,
    responsiblePersonPhoneNumber: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    setAddPremises({ ...addPremises, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setPremises(addPremises);
      if (isView) {
        navigate(`/view-premises/modules/${id}`);
      } else if (id) {
        navigate(`/update-premises/modules/${id}`);
      } else {
        navigate("/add-premises/modules");
      }
    } catch (error) {
      console.error("Failed to submit premises data", error);
      alert("Failed to add premises. Please try again.");
    }
  };

  useEffect(() => {
    const getPremisesById = async () => {
      try {
        const response = await axiosInstance.get(`/api/premises/${id}`);
        setAddPremises(response.data);
      } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
          alert("Premises not found. Please check the ID or contact support.");
          navigate("/premises");
        } else {
          console.error("Error fetching premises:", error);
          alert("An error occurred while fetching premises data.");
        }
      }
    };
    if (id) {
      getPremisesById();
    }
    if (!regions.length) fetchRegions();
  }, [id, navigate]);

  return (
    <>
      <div className="flex w-full mt-16 flex-col mb-2 justify-start px-3 items-start">
        <div className="w-full h-full flex justify-between items-center mr-4 pb-2">
          <h1>
            {isView ? "View Premises" : id ? "Update Premises" : "Add Premises"}
          </h1>

          {/* <div className="flex w-1/2 items-center justify-between"> */}
            {/* <span>
              Admin: <strong>Bhanu prasad</strong>
            </span>
            <div>
              <span>
                Create Date: <strong>09/01-2025</strong>
              </span>
            </div> */}
            <div>
              <Link to="/premises" data-discover="true">
                <button className="flex items-center px-3 py-2 bg-[#61748e] text-white rounded-full">
                  <ArrowLeft />
                  Back
                </button>
              </Link>
            </div>
          {/* </div> */}
        </div>

        <div className="w-full h-full drop-shadow-lg mr-4 rounded-t-lg bg-white flex-col">
          <div className="w-[98%] bg-gray-200 rounded-full h-2.5 mx-2">
            <div
              className="bg-[#0fa9a6] h-2.5 rounded-full"
              style={{ width: `10%` }}
            ></div>
          </div>
          <form className="w-full px-4 h-[350px]">
            <div className="font-semibold">
              <h1>Premises Details</h1>
            </div>
            <div className="grid grid-rows-3 grid-cols-3 w-full leading-none gap-y-8 gap-x-3">
              <div className="flex flex-col">
                <label className="text-lg font-semibold">Region</label>
                <select
                  name="region"
                  value={addPremises.region}
                  onChange={handleChange}
                  disabled={isView}
                  className={`py-2 border-2 border-gray-400 rounded-md ml-1 px-1 ${
                    isView ? "bg-gray-100" : ""
                  }`}
                >
                  <option value="">Select Region</option>
                  {regions.length > 0 &&
                    regions.map((region: any) => (
                      <option key={region._id} value={region._id}>
                        {region.regionName}
                      </option>
                    ))}
                </select>
                {/* <input
                  type="text"
                  className={`py-2 border-2 border-gray-400 rounded-md ml-1 px-1 ${
                    isView ? "bg-gray-100" : ""
                  }`}
                  placeholder="Region"
                  name="region"
                  readOnly={isView}
                  value={addPremises.region}
                  onChange={handleChange}
                /> */}
              </div>
              <div className="flex flex-col">
                <label className="text-lg font-semibold">Premises Name</label>
                <input
                  type="text"
                  className={`py-2 border-2 border-gray-400 rounded-md ml-1 px-1 ${
                    isView ? "bg-gray-100" : ""
                  }`}
                  placeholder="Premises Name"
                  name="premisesName"
                  readOnly={isView}
                  value={addPremises.premisesName}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-lg font-semibold">Address Line 1</label>
                <input
                  type="text"
                  className={`py-2 border-2 border-gray-400 rounded-md ml-1 px-1 ${
                    isView ? "bg-gray-100" : ""
                  }`}
                  placeholder="Address Line 1"
                  name="addressLine1"
                  value={addPremises.addressLine1}
                  readOnly={isView}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-lg font-semibold">Town/City</label>
                <input
                  type="text"
                  className={`py-2 border-2 border-gray-400 rounded-md ml-1 px-1 ${
                    isView ? "bg-gray-100" : ""
                  }`}
                  placeholder="Town/City"
                  name="townCity"
                  readOnly={isView}
                  value={addPremises.townCity}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-lg font-semibold">Post Code</label>
                <input
                  type="text"
                  className={`py-2 border-2 border-gray-400 rounded-md ml-1 px-1 ${
                    isView ? "bg-gray-100" : ""
                  }`}
                  placeholder="Post Code"
                  name="postcode"
                  readOnly={isView}
                  value={addPremises.postcode}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-lg font-semibold">
                  Responsible Person
                </label>
                <input
                  type="text"
                  className={`py-2 border-2 border-gray-400 rounded-md ml-1 px-1 ${
                    isView ? "bg-gray-100" : ""
                  }`}
                  placeholder="Responsible Person"
                  name="responsiblePerson"
                  value={addPremises.responsiblePerson}
                  readOnly={isView}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-lg font-semibold">
                  Responsible Person Mobile Number
                </label>
                <input
                  type="text"
                  className={`py-2 border-2 border-gray-400 rounded-md ml-1 px-1 ${
                    isView ? "bg-gray-100" : ""
                  }`}
                  placeholder="Mobile Number"
                  name="responsiblePersonPhoneNumber"
                  readOnly={isView}
                  value={addPremises.responsiblePersonPhoneNumber}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-lg font-semibold">No Of Floor</label>
                <input
                  type="number"
                  name="floor"
                  placeholder="No Of Floor"
                  value={addPremises.floor ?? ""}
                  onChange={(e) =>
                    setAddPremises({
                      ...addPremises,
                      floor:
                        e.target.value === ""
                          ? undefined
                          : Number(e.target.value),
                    })
                  }
                  disabled={isView}
                  className={`py-2 border-2 border-gray-400 rounded-md ml-1 px-1 ${
                    isView ? "bg-gray-100 cursor-not-allowed" : ""
                  }`}
                  min={0}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-lg font-semibold">Basement</label>
                <select
                  name="basement"
                  value={addPremises.basement ? "yes" : "no"}
                  onChange={(e) =>
                    setAddPremises({
                      ...addPremises,
                      basement: e.target.value === "yes",
                    })
                  }
                  disabled={isView}
                  className="py-2 border-2 border-gray-400 rounded-md ml-1 px-1"
                >
                  <option value="no">No</option>
                  <option value="yes">Yes</option>
                </select>
              </div>
            </div>
          </form>
          <div className="w-full mt-7 flex justify-end items-center h-18 p-2 bg-[#61748e]">
            <button
              onClick={(e) => handleSubmit(e)}
              type="submit"
              className="h-10 bg-[#0fa9a6] text-white text-lg px-5 py-1 rounded-full bottom-0 left-0 right-0"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPremises;
